module.exports = __webpack_public_path__ + "static/media/pic6.7b748b46.jpg";